import { colors } from '../constants';
const palette = {
  primary: colors.primary,
  secondary: colors.secondary,
  success: colors.success,
  warning: colors.warning,
  error: colors.error,
  info: colors.info,
  text: colors.text,
  type: 'light',
  action: colors.action,
  common: colors.commonColors,
  background: colors.background,
  grey: colors.oriGrey
};
export default palette;